import React, { useState, useEffect } from 'react';
import { View, ScrollView, Image, Text, TouchableOpacity, ActivityIndicator, Linking } from 'react-native';
import { useNavigation } from '@react-navigation/native';

import AsyncStorage from '@react-native-async-storage/async-storage';

import certificateService from '../../services/certificateService';
import { MaterialIcons } from "@expo/vector-icons";
import { formatGPXBalance } from '../../utils/formatNumber'
import styles from './styles';
import formatDate from '../../utils/formatDate';

const CardsMyCertificatesWallet = () => {
    const navigation = useNavigation();
    const [listCertificates, setListCertificates] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getCertificatesWallet()
    }, []);
    const handleOpenCertificate = (uuid) => {
        Linking.openURL(`http://api.gpxexchange.com.br/certificates/view/${uuid}`)
    }
    const getCertificatesWallet = async () => {
        setLoading(true)
        const authToken = await AsyncStorage.getItem('JWT_TOKEN');
        certificateService.get(authToken).then((response) => {
            if (response.data.length > 0) {
                setListCertificates(response.data);
                //console.log(response.data);
            }
            setLoading(false)
        }).catch((error) => {
            setLoading(false)
            //console.log(error);
        });
    }
    return <>
        {
            loading ? <View style={styles.center}><ActivityIndicator size="large" color="#1FBFB5" /></View> :
                (<>
                    <ScrollView contentContainerStyle={styles.scrollViewContent} nestedScrollEnabled={true}>
                        {listCertificates !== null ?
                            listCertificates.map((item, index) =>
                                <TouchableOpacity style={styles.contentItem}
                                    onPress={() => handleOpenCertificate(item.uuid)}
                                    key={index}>
                                    {item.path ?
                                        <Image source={{ uri: 'https://filesgpx.s3.us-east-2.amazonaws.com/' + item.path }} style={styles.img} />
                                        :
                                        <Image source={require('../../../assets/gpxcarbo.png')} style={styles.img} />
                                    }
                                    <View style={styles.textsItem}>
                                        <Text style={styles.titleCoin}>Crédito de Carbono</Text>
                                        <View style={styles.infoPrice}>
                                            <Text style={styles.infosCoin}>Data:</Text>
                                            <Text style={styles.priceCoin}> {formatDate(item.created_at)}</Text>
                                        </View>
                                    </View>
                                    <MaterialIcons
                                        name="keyboard-arrow-right"
                                        size={30}
                                        color="#2C2C2E"
                                        style={styles.iconGo}
                                    />
                                </TouchableOpacity>)
                            : <Text style={styles.titleCoin}>Sem certificados</Text>
                        }
                    </ScrollView>
                </>)
        }
    </>
}

export default CardsMyCertificatesWallet
